import React from 'react'
import PropTypes from 'prop-types'

import { SITE_PICKER_HEADER } from './constants'
import { StyledFormInputSelect } from './component.styles'
import { SkuCodeToDisplay } from 'lib/util'

const SitePicker = ({ sites, onSiteChange, selectedSite }) => {
  const disabled = ({ component }) => !!component

  const createLicenseList = site => {
    const displayItems = []
    site.netSuiteAssets.forEach(lic => {
      if (lic.status !== 'Expired' && lic.product && lic.product.programCodes) {
        lic.product.programCodes.forEach(code => {
          const display = SkuCodeToDisplay[code] || {
            productCode: 'N/A',
            hierarchy: 9999,
          }
          displayItems.push(display)
        })
      }
    })
    return [
      ...new Set(
        displayItems
          .sort((a, b) => a.hierarchy - b.hierarchy)
          .map(display => display.productCode),
      ),
    ]
  }

  const formatSite = site => {
    let schoolCount = 0
    sites.forEach(s => {
      if (s.name === site.name) {
        schoolCount++
      }
    })
    const siteHasADuplicate = schoolCount > 1

    if (!siteHasADuplicate) return site.name || 'Your School'

    const licenseList = createLicenseList(site)
    const formattedName = `${site.name || 'Your School'} ${
      licenseList.length > 0 ? '-' : ''
    } ${licenseList.join(', ')}`

    return formattedName
  }

  return (
    <StyledFormInputSelect
      autoComplete={false}
      autofocus={false}
      dataTestId="form-input-select-site"
      disabledKey={disabled}
      label={SITE_PICKER_HEADER}
      name="role"
      onChange={onSiteChange}
      optionKey={formatSite}
      options={sites}
      value={selectedSite}
      valueKey={formatSite}
    />
  )
}

SitePicker.propTypes = {
  onSiteChange: PropTypes.func.isRequired,
  selectedSite: PropTypes.object,
  sites: PropTypes.arrayOf(PropTypes.object),
}

SitePicker.defaultProps = {
  sites: [],
  onSiteChange: () => {},
}

export default SitePicker
